export const faqs = [
  {
    id: 1,
    question: "木瓜影院是否真的免费？",
    answer: "是的，木瓜影院完全免费。我们致力于为广大影迷提供优质的影视资源导航服务，所有内容均无需付费或注册即可浏览。我们通过广告和推荐来维持平台运营，绝不会向用户收取任何费用。"
  },
  {
    id: 2,
    question: "木瓜影院的影视资源更新速度如何？",
    answer: "木瓜影院的资源更新速度在同类平台中名列前茅。热门电影通常在院线下映后7-15天内即可上线，热门电视剧和综艺节目一般会在播出后24小时内同步更新，让您不用等待太久就能看到想看的内容。"
  },
  {
    id: 3,
    question: "支持哪些设备和浏览器？",
    answer: "木瓜影院全面支持PC端、平板和手机端浏览。推荐使用Chrome、Safari、Edge等主流浏览器访问，以获得最佳观影体验。我们的网站采用响应式设计，在不同设备上都能获得良好的视觉效果。"
  },
  {
    id: 4,
    question: "视频画质如何？有高清资源吗？",
    answer: "木瓜影院提供的影视资源以高清为主，大部分内容支持1080P超清画质，部分热门大片更支持4K画质。我们会根据您的网络状况自动调整画质，确保流畅的观看体验。平台标注了「HD」「超清」「蓝光」等标签，方便您选择。"
  },
  {
    id: 5,
    question: "如何搜索想看的影片？",
    answer: "您可以通过网站顶部的搜索框直接输入影片名称进行搜索，也可以通过首页的分类导航（电影、电视剧、综艺、动漫）浏览不同类型的内容。我们还提供了评分排行和最新更新列表，帮助您发现更多好片。"
  },
  {
    id: 6,
    question: "遇到播放问题怎么办？",
    answer: "如果遇到播放问题，我们建议您：1) 尝试切换播放线路，木瓜影院为大部分影片提供了多条播放线路；2) 检查您的网络连接是否稳定；3) 清除浏览器缓存后重试；4) 如果问题持续存在，可以通过关于我们页面的联系方式反馈给我们。"
  }
];